import { ThisReceiver } from '@angular/compiler';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { FirebaseService } from 'src/app/commons/firebase.service';
import { FunctionsService } from 'src/app/data/functions.service';
import { RegistroClienteComponent } from '../cliente/registro/registro-cliente.component';

@Component({
  selector: 'app-adiciona-produto-vendedor',
  templateUrl: './adiciona-produto-vendedor.component.html',
  styleUrls: ['./adiciona-produto-vendedor.component.css']
})
export class AdicionaProdutoVendedorComponent implements OnInit {
  @ViewChild('adicionaProdutoStepper') adicionaProdutoStepper: MatStepper;
  @ViewChild(RegistroClienteComponent) registroClienteComponent: RegistroClienteComponent;
  public loading: boolean = false;
  public adicionaProdutoFormGroup: UntypedFormGroup;
  public usuarioEstaLogado: boolean;
  public usuarioJaTemUmaConta: boolean;

  public condicoesProdutos = [
    { label: 'Novo', codigo: 'novo' },
    { label: 'Usado', codigo: 'usado' }
  ]

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public firebase: FirebaseService,
    private formBuilder: UntypedFormBuilder,
    private functions: FunctionsService
  ) { }

  ngOnInit(): void {

    this.usuarioJaTemUmaConta = false;
    this.usuarioEstaLogado = this.firebase.user ? true : false;
    const dimensoes = this.data?.dimensoes || {};
    const { altura, largura, peso, comprimento } = dimensoes;
    console.log(this.data)
    const isAlturaRequired = !altura || altura <= 0;
    const isLarguraRequired = !largura || largura <= 0;
    const isComprimentoRequired = !comprimento || comprimento <= 0;
    const isPesoRequired = !peso || peso <= 0;

    this.adicionaProdutoFormGroup = this.formBuilder.group({
      novo: [{ value: false, disabled: false }, [
        Validators.required
      ]],
      usado: [{ value: false, disabled: false }, [
        Validators.required
      ]],
      lance_automatico: [{ value: false, disabled: false }, [
        Validators.required,
      ]],
      robo_inversu: [{ value: false, disabled: false }, [
        Validators.required,
      ]],
      valor_lance_inicial: [{ value: '', disabled: false }, [
        Validators.min(1),
        Validators.max(9999999999999.99)
      ]],
      valor_minimo_final: [{ value: '', disabled: true }, [
        Validators.min(1),
        Validators.max(9999999999999.99)
      ]],
      valor_a_diminuir: [{ value: '', disabled: true }, [
        Validators.min(1),
        Validators.max(9999999999999.99)
      ]],
      comprimento: [{ value: comprimento || 0, disabled: !isComprimentoRequired }, [
        isComprimentoRequired ? Validators.required : [],
        Validators.min(1),
        Validators.max(999999)
      ]],
      altura: [{ value: altura || 0, disabled: !isAlturaRequired }, [
        isAlturaRequired ? Validators.required : [],
        Validators.min(1),
        Validators.max(999999)
      ]],
      largura: [{ value: largura || 0, disabled: !isLarguraRequired }, [
        isLarguraRequired ? Validators.required : [],
        Validators.min(1),
        Validators.max(999999)
      ]],
      peso: [{ value: peso || 0, disabled: !isPesoRequired }, [
        isPesoRequired ? Validators.required : [],
        Validators.min(0.05),
        Validators.max(200000)
      ]],
      retirada_local: [{ value: true, disabled: false }, [
        Validators.required
      ]]
    });
  }

  registroFinalizado(resultado: string) {
    if (resultado === 'login') {
      this.usuarioJaTemUmaConta = true;
      this.usuarioEstaLogado = false;
    } else if (resultado === 'finalizado') {
      this.adicionaProdutoStepper.next();
    }
  }

  acessoFinalizado(resultado: string) {
    if (resultado === 'registrar') {
      this.usuarioJaTemUmaConta = false;
      this.usuarioEstaLogado = false;
    } else if (resultado === 'finalizado') {
      this.adicionaProdutoStepper.next();
    }
  }

  catalogProdutos() {
    this.router.navigateByUrl(`/negociacoes`);
  }

  incluirProduto() {
    this.adicionaProdutoFormGroup.markAllAsTouched();

    if (this.adicionaProdutoFormGroup.invalid) {
      alert('Por favor, preencher todos os campos obrigatórios');
      return
    }

    const payload: any = {};

    Object.keys(this.adicionaProdutoFormGroup.controls).forEach(key => {
      payload[key] = this.adicionaProdutoFormGroup.controls[key].value;
    });

    if (!payload.novo && !payload.usado) {
      alert('Por favor, nos informe a condição do produto');
      return
    }

    this.loading = true;
    this.adicionaProdutoFormGroup.disable();

    if (payload.valor_lance_inicial === '') payload.valor_lance_inicial = 0;
    if (payload.valor_minimo_final === '') payload.valor_minimo_final = 0;
    if (payload.valor_a_diminuir === '') payload.valor_a_diminuir = 0;

    payload.ean = this.data.ean;
    payload.dimensoes = { altura: payload.altura, largura: payload.largura, comprimento: payload.comprimento, peso: payload?.peso }
    if (Object.values(payload.dimensoes).some(p => p === undefined || p === null || typeof p !== 'number')) {
      alert('Dimensões invalidas');
      return
    }
    payload.recondicionado = payload?.recondicionado || false
    this.functions.addProdutoCliente(payload)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.adicionaProdutoFormGroup.enable();
        })
      )
      .subscribe(
        {
          next: res => {
            this.adicionaProdutoStepper.next();
          },
          error: error => {
            console.error(error);
            alert('Ops, não conseguimos adicionar esse produto ao seu estoque. Por favor, tente mais tarde.');
          }
        });
  }

  meusProdutos() {
    this.dialogRef.close();
    this.router.navigateByUrl(`/minha-conta/meus-produtos`);
  }

  alteraLanceAutomatico() {
    if (!this.adicionaProdutoFormGroup) return;
    let control = this.adicionaProdutoFormGroup.controls['valor_lance_inicial'];

    if (this.adicionaProdutoFormGroup.controls['lance_automatico']?.value === true) {
      control.addValidators(Validators.required)
    } else {
      control.removeValidators(Validators.required);
      control.setErrors(null);
    }

    this.adicionaProdutoFormGroup.updateValueAndValidity();
  }

  changeRoboInversu() {
    let control1 = this.adicionaProdutoFormGroup.controls['valor_a_diminuir'];
    let control2 = this.adicionaProdutoFormGroup.controls['valor_minimo_final'];

    if (this.adicionaProdutoFormGroup.controls['robo_inversu']?.value === true
      && this.adicionaProdutoFormGroup.controls['lance_automatico']?.value === true) {
      control1.addValidators(Validators.required)
      control1.enable()
      control2.addValidators(Validators.required)
      control2.enable()
    } else {
      control1.enable()
      control1.removeValidators(Validators.required);
      control1.disable()
      control1.setValue('')
      control1.setErrors(null);
      control2.removeValidators(Validators.required);
      control2.disable()
      control2.setValue('')
      control2.setErrors(null);
    }

    this.adicionaProdutoFormGroup.updateValueAndValidity();
  }
}
